// This file was auto-generated by Fern from our API Definition.
/**
 * Where a session's name came from: a person, or a program.
 *
 * It governs the name only, never the description, and it is not caller identity — both
 * kinds of request run under the same user credential. ``manual`` is a person typing a
 * name. ``automatic`` is a program proposing one: the agent's own ``rename_session``, or
 * the browser's auto-title from a first message.
 *
 * It travels as a query parameter, never in the body, so a model cannot claim a person
 * chose its name: the ``rename_session`` catalog entry fixes ``name_source=automatic``
 * inside its own path and the model only ever fills the body.
 *
 * ``manual`` is the default, which is a real trade rather than a free win. An unmarked
 * caller (a script, a service running an older SDK during a rolling deploy) is read as a
 * person, so an automatic name it writes is remembered as person-chosen and the next
 * agent rename of that session is refused until a person renames it. That is the
 * recoverable direction. The other default loses a person's name instead.
 */
export const SessionNameSource = {
    Manual: "manual",
    Automatic: "automatic",
};
